var map = {
	"./about-applications-bg-mobile.png": "4294",
	"./about-applications-bg.png": "7746",
	"./card-with-logo.png": "925c",
	"./check.png": "722d",
	"./download-on-the-appstore.png": "9bb1",
	"./english.png": "c59c",
	"./footer-bg-mobile.png": "389a",
	"./footer-bg.png": "ec49",
	"./get-it-on-google-play.png": "1174",
	"./payments-logo.png": "1229",
	"./phone_1.png": "1e81",
	"./phone_2.png": "2e49",
	"./phone_3.png": "2e2a",
	"./popups-from-the-site.png": "1589",
	"./ukraine.png": "7229"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";